export default __webpack_public_path__ + "b38a0052c44b2d36db613d8c86863dc4.png";